module.exports = __webpack_public_path__ + "assets/img/reserved-heroes-aec25c3b.png";